import { ValueDescriptor } from "~/types/Variable";

export const unwrapValueDescriptor = (value: ValueDescriptor) => {
  return value.value;
};
